<template>
    <div>
        <!-- Header container -->
        <div class="header pb-2 d-flex align-items-center bg-howto">
            <div class="container align-items-center mt-9 mb-4">
                <div class="row mb-5">
                    <div class="col">
                        <h1 class="display-1 text-white mt-0 mb-5 text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Как подключить мессенджер Командор?
                        </h1>
                        <h1 class="text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Всего несколько шагов и вы у цели!
                        </h1>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>
        <!-- // Header container -->

        <div class="container mt-6 mb-6">
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">1. Сертификат</h1>
                    <p>
                        Для подключения и регистрации в Командоре, необходимо иметь действующий квалифицированный сертификат
                        ЭП выданный аккредитованным удостоверяющим центром.
                    </p>
                    <p>
                        Так же вы можете использовать не квалифицированный сертификат ЭП получив его в личном кабинете на сайте.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h1 class="mb-4">2. КриптоПро CSP</h1>
                    <p>
                        Для использования Командора на компьютере с операционной системой Windows или macOS, необходимо
                        установить последнюю сертифицированную версию КриптоПро CSP 4.0 R3/R4 или CSP 5.0 (<a href="https://www.cryptopro.ru/downloads" target="_blank">скачать</a>)
                    </p>
                    <p>Для мобильных устройств достаточно установить только приложение Командор.</p>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row">
                <div class="col-8">
                    <h1 class="mb-4">3. Регистрация профиля</h1>
                    <p>
                        При первом входе в Командор, необходимо указать ваш мобильный номер телефона для регистрации и
                        привязки профиля.
                    </p>
                </div>
                <div class="col-4"></div>
            </div>
        </div>

    </div>
</template>
<script>
  export default {
    data () {
      return {
        // color: 'rgb(255,255,255, 1)'
        color: '#ced4da'
      }
    },
  };
</script>
<style>
    .bg-howto {
        background-image: url(/img/bg-howto.jpg);
        background-size: cover;
        background-position: center top;
        min-height: 525px;
    }
</style>
